import { render, staticRenderFns } from "./UplodeMultiple.vue?vue&type=template&id=f6d0bb7c&scoped=true"
import script from "./UplodeMultiple.vue?vue&type=script&lang=js"
export * from "./UplodeMultiple.vue?vue&type=script&lang=js"
import style0 from "./UplodeMultiple.vue?vue&type=style&index=0&id=f6d0bb7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d0bb7c",
  null
  
)

export default component.exports